import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import XLSX from "xlsx";

import telematicsService from "../../api/telematics.service";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import EventBus from "../../utils/EventBus";
import googleMapsService from "../../api/googleMaps.service";
import config from "@/config";
import rules from "../../utils/rules";
import { VueDraggableCard } from "vue-draggable-card";
import { sortItems } from "vuetify/lib/util/helpers";
Vue.use(VueGoogleMaps, {
  load: {
    key: config.GOOGLE_MAPS_API,
    libraries: "places",
  },
});
Vue.component("gmap-autocomplete", VueGoogleMaps.Autocomplete);

export default {
  name: "map1",
  components: { VueDraggableCard, pageheader, GmapCluster },
  data() {
    return {
      rules: rules,
      showReset: false,
      modelSearchFilter: "",
      groupSearchFilter: "",
      brandSearchFilter: "",
      locationSearchFilter: null,
      gpsReadingSearchFilter: "",
      menu1: false,
      menufilter: false,
      isStatsLoading: false,
      loading: false,
      zonesList: [],
      selectedZone: [],
      zoneSearchFilter: "",
      loadinglocations: false,
      markerDataTable: [],
      statsData: {},
      isStatsDataAvailable: false,
      searchField: "",
      searchContractId: "",
      searchStoreId: "",
      contractIdFilter: false,
      storeIdFilter: false,

      searchFieldAddress: "",
      pageheaderKey: "pageheader" + String(Math.random()),
      svgMarkerRed: {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: "#bf2e1a",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
      },
      svgMarkerBlack: {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: "#000",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
      },
      input: {},
      selected: [
        "Status",
        "Asset Type",
        "Brand",
        "Rental Status",
        "Model",
        "Geofence",
        "Group",
        "Type",
        "GPS Reading",
        "Jobsite",
      ],

      filterTypes: [
        { id: "1", name: "Asset Type" },
        { id: "2", name: "Brand" },
        { id: "8", name: "Rental Status" },
        { id: "3", name: "Model" },
        { id: "4", name: "Geofence" },
        { id: "5", name: "Group" },
        { id: "6", name: "Type" },
        { id: "10", name: "GPS Reading" },
        { id: "7", name: "Jobsite" },
      ],
      hidePOI: false,
      hideCustomGeofences: false,
      lowFuel: false,
      lowDef: false,
      lowVoltage: false,
      selectedsubtype: "",
      tab: 0,
      center: {},
      zoom: 4.6,
      markers: [],
      rentalDetailsList: [],
      filterDialog: false,
      isApplyFilter: false,
      search: "",
      selectedGroup: [],
      status: [
        { name: "View All Equipment", status: "0" },
        { name: "Overdue", status: "1" },
      ],
      ownershipTypes: [],
      Types: [
        { name: "Rental & Asset", value: "all" },
        { name: "Rental", value: "rental" },
        { name: "Asset", value: "asset" },
      ],
      subTypes: [
        { name: "Low Fuel", value: "lowFuel" },
        { name: "Low DEF", value: "lowDef" },
        { name: "Low Voltage", value: "lowVoltage" },
      ],
      selectedOwnershipType: ["1", "2"],
      selectedAsset: ["CAN", "spot"],
      selectedOwnershipFinal: "",
      selectedAssetFinal: "",
      assets: [
        { id: "CAN", name: "CAN" },
        { id: "spot", name: "Spot" },
      ],
      brands: [],
      models: [],
      locations: [],

      selectedBrand: [],
      selectedModel: [],
      rentalStatusMenu: false,
      selectedLocation: [],

      groups: [],
      imageExists: false,
      locationDetails: {},
      infowindowdiv: false,
      mapColValue: "10",
      toggle_exclusive_map: undefined,
      // declared so Vue tracks them: the first is the contracts grid/list
      // toggle's v-model, the second is the contracts table's options.sync
      toggle_exclusive_contracts: undefined,
      options: {},
      excelList: [],
      excelHeader: [],
      startrow: "",
      currentMapTypeId: "",
      // Options to pass along to the marker clusterer
      clusterOptions: [
        {
          textColor: "white",
          url: require("../../assets/cluster.png"),
          height: 32,
          width: 32,
          textSize: 12,
        },
      ],

      headers: [
        { text: "Logo", value: "actionIcon", sortable: false, align: "left" },
        { text: "Contract#", value: "contractNumber" },
        { text: "Job Name", value: "jobName" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Status", value: "status" },
        { text: "No.of equipment", value: "noOfEquipment" },
        { text: "Actions", value: "action" },
      ],
      header_map: [],
      series: [],
      chartOptions: {
        chart: {
          width: 580,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  fontWeight: 600,
                  fontFamily:
                    "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
                  fontSize: "14px",
                },
                total: {
                  showAlways: true,
                  show: true,
                  fontWeight: 600,
                  fontFamily:
                    "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
                  fontSize: "14px",
                },
              },
            },
          },
        },
        responsive: [
          {
            options: {
              chart: {
                width: 580,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
          show: true,
          horizontalAlign: "center",
          verticalAlign: "center",
          fontWeight: 600,
          fontFamily:
            "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
          fontSize: "14px",
        },
        colors: ["#C70039"],

        labels: ["Overdue"],
      },
      telematics_series: [],
      telematics_chartOptions: {
        chart: {
          width: 580,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  fontWeight: 600,
                  fontFamily:
                    "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
                  fontSize: "12px",
                },
                total: {
                  showAlways: true,
                  show: true,
                  fontWeight: 600,
                  fontFamily:
                    "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
                  fontSize: "12px",
                },
              },
            },
          },
        },
        responsive: [
          {
            options: {
              chart: {
                width: 580,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
          show: true,
          horizontalAlign: "center",
          verticalAlign: "center",
          fontWeight: 600,
          fontFamily:
            "Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif",
          fontSize: "14px",
        },
        colors: ["#D7263D", "#000000de"],
        labels: ["Birch Owned", "Customer Owned"],
      },
      polygons: [],
      polygonsFiltered: [],
      polygonOptions: {
        strokeColor: "#880808",
        strokeOpacity: 0.8,
        strokeWeight: 5,
        fillColor: "#880808",
        fillOpacity: 0.35,
      },
      zonewindowdiv: false,
      zoneDetails: {},
      selectedRentalStatus: [],
      rentalStatusList: [
        {
          statusId: "Overdue",
          statusName: "Overdue",
        },
      ],
      rentalStatusListForNonCustomers: [
        {
          statusId: "Reservation",
          statusName: "Reservation",
        },
        {
          statusId: "OnRent",
          statusName: "On Rent",
        },
        {
          statusId: "OffRent",
          statusName: "Off Rent",
        },
        {
          statusId: "Available",
          statusName: "Available",
        },
        {
          statusId: "Overdue",
          statusName: "Overdue",
        },
      ],
      isOwnerFilter: false,
      ownerTypeQuery: {},
      isAssetFilter: false,
      assetTypeQuery: {},
      isBrandFilter: false,
      brandQuery: {},
      isRentalStatusFilter: false,
      rentalQuery: {},
      isModelFilter: false,
      modelQuery: {},
      isZoneFilter: false,
      zoneQuery: {},
      isGroupFilter: false,
      groupQuery: {},
      isSubTypeFilter: false,
      subTypeQuery: {},
      isLocationFilter: false,
      locationQuery: {},
      isContractSearchFilter: false,

      searchFieldQuery: {},
      searchContractFieldQuery: {},
      addressSearchQuery: {},
      isAlertsFilter: false,
      alertsQuery: {},
      isLastGPSReadingFilter: false,
      GPSReadingQuery: {},
      finalRouteQuery: {},
      viewfinalRouteQuery: {},
      showDialog: false,
      pageNumber: 1,
      pageSize: 52,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "52",
          count: 52,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      totalRecords: 0,
      totalRecordsCount: 0,
      isContractsLoading: false,
      nodata: false,
      yesdata: false,
      shownodata: false,
      tempList: [],
      contractsList: [],
      excelListContracts: [],
      excelHeaderContracts: [],
      startrowContracts: "",
      showtoggle: false,
      headers_LineItems: [
        { text: "Equipment #", value: "stockKey" },
        { text: "Equipment Name", value: "name" },
        { text: "Serial Number", value: "serialNumber" },
        { text: "Quantity", value: "quantity" },
      ],
      activeheaders: [
        { text: "Contract#", value: "name", width: "12%" },
        { text: "Line Items", value: "lineItems", width: "30%" },
        { text: "PO#", value: "customerPurchaseOrder" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up by", value: "receivedBy" },
        { text: "Job Number", value: "customerJobNumber" },
        { text: "Date Out", value: "startDateTime" },
        { text: "Date Due", value: "endDateTime" },
        { text: "Status", value: "contractStatus" },
        { text: "Actions", value: "action" },
      ],
      showdriverPickup: true,
      showdriverdelivery: true,
      contractsDialogClass: "contracts-expanded",
      isDetailsLoading: false,
      viewDataById: {},
      responseData: {
        driverDelivery: {
          dateTime: "",
        },
        customerPickup: {
          dateTime: "",
        },
        driverPickup: {
          dateTime: "",
        },
      },
      activeSearch: "",
      actualEquipmentsCount: "",
      locationsFiltered: "",
      actualLocationsFromAPi: "",
      selectedAlert: "",
      gpsReadingList: [
        { name: "Any Time", value: "0", disabled: false },
        { name: "Last Hour", value: "1", disabled: false },
        { name: "Last 24 Hours", value: "2", disabled: false },
        { name: "Last 7 Days", value: "3", disabled: false },
        { name: "Last 30 Days", value: "4", disabled: false },
        { name: "More Than 30 Days", value: "5", disabled: false },
      ],
      selectedGPSReading: [],
      showGeofenceSearchFilters: false,
      userCurrentLocation: {},
      currentLocationPolygons: [],
      createdPolygonsList: [],
      finalGeofencePaths: [],
      selectedgeofenceSearchItem: "",
      name: "",
      description: "",
      valid: true,
      isCreating: false,
      isDisplayInfoDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "id",
      "companyNameDropdown",
      "companyIdDropdown",
      "activeToggleBtnVal",
      "activeContractsToggleBtnVal",
      "permissions",
      "fullname",
    ]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.contractsList.length
        : (this.pageNumber - 1) * this.pageSize + this.contractsList.length;
    },
  },
  watch: {
    locationSearchFilter(val) {
      if (val != undefined && val != null) {
        return val.replace(/^\s+|\s+$/gm, "");
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
    formatDateValue: function (value) {
      if (value) {
        let date = value.split("T")[0];
        return moment(date).format("L");
      }
    },
  },
  created() {
    if (
      this.permissions.includes("Customer Owned Equipment") &&
      this.permissions.includes("On Rent Equipment")
    ) {
      this.ownershipTypes = [
        { name: "Birch Owned", value: "1" },
        { name: "Customer Owned", value: "2" },
      ];
      this.selectedOwnershipType = ["1", "2"];
    } else if (
      !this.permissions.includes("Customer Owned Equipment") &&
      this.permissions.includes("On Rent Equipment")
    ) {
      this.ownershipTypes = [
        { name: "Birch Owned", value: "1" },
      ];
      this.selectedOwnershipType = ["1"];
      this.selectedOwnershipFinal = "1";
    } else if (
      this.permissions.includes("Customer Owned Equipment") &&
      !this.permissions.includes("On Rent Equipment")
    ) {
      this.ownershipTypes = [
        { name: "Customer Owned", value: "2" },
      ];
      this.selectedOwnershipType = ["2"];
      this.selectedOwnershipFinal = "2";
    }

    this.toggle_exclusive_map = this.activeToggleBtnVal;
    this.toggle_exclusive_contracts = this.activeContractsToggleBtnVal;
    // Owner Type Filter
    if (this.$route.query && this.$route.query.isOwnerFilter) {
      this.selectedOwnershipType = this.$route.query.ownerTypeValue
        ? this.$route.query.ownerTypeValue.split(",")
        : [];
      (this.selectedOwnershipFinal = this.$route.query.ownerFinalValue),
        (this.isOwnerFilter = true);
    }
    //Asset Type Filter
    if (this.$route.query && this.$route.query.isAssetFilter) {
      this.selectedAsset = this.$route.query.assetValue
        ? this.$route.query.assetValue.split(",")
        : [];
      (this.selectedAssetFinal = this.$route.query.assetFinalValue),
        (this.isAssetFilter = true);
    }
    //Brand Filter
    if (this.$route.query && this.$route.query.isBrandFilter) {
      this.selectedBrand = this.$route.query.brandValue
        ? this.$route.query.brandValue.split(",")
        : [];
      this.isBrandFilter = this.$route.query.isBrandFilter;
    }
    // Rental Status filter
    if (this.$route.query && this.$route.query.isRentalStatusFilter) {
      this.selectedRentalStatus = this.$route.query.rentalValue.split(",");
      this.isRentalStatusFilter = this.$route.query.isRentalStatusFilter;
    }
    //Model Filter
    if (this.$route.query && this.$route.query.isModelFilter) {
      this.selectedModel = this.$route.query.modelValue
        ? this.$route.query.modelValue.split(",")
        : [];
      this.isModelFilter = this.$route.query.isModelFilter;
    }
    //Group Filter
    if (this.$route.query && this.$route.query.isGroupFilter) {
      this.selectedGroup = this.$route.query.groupValue
        ? this.$route.query.groupValue.split(",")
        : [];
      this.isGroupFilter = this.$route.query.isGroupFilter;
    }
    //Zone/Geofence Filter
    if (this.$route.query && this.$route.query.isZoneFilter) {
      this.selectedZone = this.$route.query.geofenceValue
        ? this.$route.query.geofenceValue.split(",")
        : [];
      this.isZoneFilter = this.$route.query.isZoneFilter;
    }
    // Type Filter
    // Alerts Filter
    if (this.$route.query && this.$route.query.isAlertsFilter) {
      this.selectedAlert = this.$route.query.alertValue;
      this.isAlertsFilter = true;
    }
    // Sub Type Filter
    if (this.$route.query && this.$route.query.isSubTypeFilter) {
      this.selectedsubtype = this.$route.query.subTypeValue;
      this.lowVoltage = this.$route.query.lowVoltage;
      this.lowDef = this.$route.query.lowDef;
      this.lowFuel = this.$route.query.lowFuel;
      this.isSubTypeFilter = true;
    }
    // Activity filter

    // GPS Reading filter
    if (this.$route.query && this.$route.query.isLastGPSReadingFilter) {
      this.selectedGPSReading = this.$route.query.gpsReadingValue
        ? this.$route.query.gpsReadingValue.split(",")
        : [];
      this.isLastGPSReadingFilter = this.$route.query.isLastGPSReadingFilter;
      let checkValue = this.selectedGPSReading.includes("0");
      if (checkValue) {
        this.selectedGPSReading = ["0"];
        this.gpsReadingList.forEach((item) => {
          if (item.value != "0") {
            item.disabled = true;
          }
        });
      } else {
        this.gpsReadingList.map((item) => {
          item.disabled = false;
          return item;
        });
      }
    }
    //Location Filter
    if (this.$route.query && this.$route.query.isLocationFilter) {
      this.selectedLocation = this.$route.query.locationValue
        ? this.$route.query.locationValue.split(",")
        : [];
      this.isLocationFilter = this.$route.query.isLocationFilter;
    }
    //Search Field Filter
    if (this.$route.query && this.$route.query.isContractSearchFilter) {
      if (this.$route.query.searchFieldValue.includes("%23")) {
        this.searchField = decodeURIComponent(
          this.$route.query.searchFieldValue
        );
      } else {
        this.searchField = this.$route.query.searchFieldValue;
      }
      this.isContractSearchFilter = this.$route.query.isContractSearchFilter;
    }
    if (this.$route.query && this.$route.query.contractIdFilter) {
      this.searchContractId = this.$route.query.searchContractFieldValue;
      this.contractIdFilter = this.$route.query.contractIdFilter;
    }
    if (this.$route.query && this.$route.query.contractkey) {
      this.searchContractId = this.$route.query.contractkey;

      this.contractIdFilter = this.$route.query.contractIdFilter;
    }

    if (this.$route.query && this.$route.query.storeIdFilter) {
      this.searchStoreId = this.$route.query.searchStoreFieldValue;
      this.storeIdFilter = this.$route.query.storeIdFilter;
    }
    if (this.$route.query && this.$route.query.storekey) {
      this.searchStoreId = this.$route.query.storekey;

      this.storeIdFilter = this.$route.query.storeIdFilter;
    }

    if (this.$route.query && this.$route.query.searchkey) {
      if (this.$route.query.searchkey.includes("%23")) {
        this.searchField = decodeURIComponent(this.$route.query.searchkey);
      } else {
        this.searchField = this.$route.query.searchkey;
      }
      this.isContractSearchFilter = this.$route.query.isContractSearchFilter;
    }
    if (this.$route.query && this.$route.query.contractkey) {
      this.searchContractId = this.$route.query.contractkey;

      this.contractIdFilter = this.$route.query.contractIdFilter;
    }
    if (this.$route.query && this.$route.query.storekey) {
      if (this.$route.query.storekey.includes("%23")) {
        this.searchStoreId = decodeURIComponent(this.$route.query.storekey);
      } else {
        this.searchStoreId = this.$route.query.storekey;
      }
    }
    //Address Search Filter

    EventBus.$on("call-map", this.onCallMapReadCities);
    if (this.roles != "Customer") {
      this.readCities();
    }
  },
  mounted() {
    // getting input content

    this.input = utils.getInputContent("map", this.roles);
    if (this.$route.query && this.$route.query.searchkey) {
      if (this.$route.query.searchkey.includes("%23")) {
        this.searchField = decodeURIComponent(this.$route.query.searchkey);
      } else {
        this.searchField = this.$route.query.searchkey;
      }
    }
    if (this.$route.query && this.$route.query.contractkey) {
      this.searchContractId = this.$route.query.contractkey;

    }
    if (this.$route.query && this.$route.query.storekey) {
      if (this.$route.query.storekey.includes("%23")) {
        this.searchStoreId = decodeURIComponent(this.$route.query.storekey);
      } else {
        this.searchStoreId = this.$route.query.storekey;
      }
    }

    if (this.roles == "Customer") {
      if (
        this.companyIdDropdown == 7620 ||
        this.companyIdDropdown == 5704 ||
        this.companyIdDropdown == 1540
      ) {
        this.header_map = [
          { text: "Map", value: "map" },
          { text: "Equipment #", value: "stockKey", width: "200px" },
          { text: "Equipment Name", value: "name", width: "200px" },
          { text: "Customer Name", value: "customerName", width: "200px" },
          { text: "Contract#", value: "contractId", width: "200px" },

          { text: "Date Out", value: "contractStartDate" },
          { text: "Estimated Return Date", value: "contractEndDate" },
          { text: "Rental/Asset", value: "isCustomerOwned" },
          { text: "Asset Type", value: "assetType" },
          { text: "Rental Status", value: "contractStatus" },
          { text: "Item Status", value: "itemStatus" },

          { text: "Brand", value: "manufacturer" },
          { text: "Model", value: "model" },
          { text: "Telematics SN", value: "tuSerialNumber" },
          { text: "Machine Battery Voltage", value: "battery" },
          { text: "DEF Level", value: "def" },
          { text: "Fuel Level", value: "fuel" },
          { text: "Payload Percentage", value: "payLoad" },
          { text: "Jobsite", value: "jobSite", width: "200px" },

          { text: "Description", value: "description", width: "500px" },

          { text: "Contractor", value: "contractor" },

          { text: "Start Date", value: "startDate" },

          { text: "End Date", value: "endDate" },
          {
            text: "Last Known Address",
            value: "lastKnownAddress",
            width: "200px",
          },
        ];
      } else {
        this.header_map = [
          { text: "Map", value: "map" },
          { text: "Equipment #", value: "stockKey", width: "200px" },
          { text: "Equipment Name", value: "name", width: "200px" },
          { text: "Customer Name", value: "customerName", width: "200px" },
          { text: "Contract#", value: "contractId", width: "200px" },

          { text: "Date Out", value: "contractStartDate" },
          { text: "Estimated Return Date", value: "contractEndDate" },
          { text: "Rental/Asset", value: "isCustomerOwned" },
          { text: "Asset Type", value: "assetType" },
          { text: "Rental Status", value: "contractStatus" },
          { text: "Item Status", value: "itemStatus" },
          { text: "Brand", value: "manufacturer" },
          { text: "Model", value: "model" },
          { text: "Telematics SN", value: "tuSerialNumber" },
          { text: "Machine Battery Voltage", value: "battery" },
          { text: "DEF Level", value: "def" },
          { text: "Fuel Level", value: "fuel" },
          { text: "Payload Percentage", value: "payLoad" },
          { text: "Jobsite", value: "jobSite", width: "200px" },

          {
            text: "Last Known Address",
            value: "lastKnownAddress",
            width: "200px",
          },
        ];
      }
    } else {
      this.header_map = [
        { text: "Map", value: "map" },
        { text: "Equipment #", value: "stockKey", width: "200px" },
        { text: "Equipment Name", value: "name", width: "200px" },
        { text: "Customer Name", value: "customerName", width: "200px" },
        { text: "Contract#", value: "contractId", width: "200px" },

        { text: "Date Out", value: "contractStartDate" },
        { text: "Estimated Return Date", value: "contractEndDate" },
        { text: "Rental/Asset", value: "isCustomerOwned" },
        { text: "Asset Type", value: "assetType" },
        { text: "Rental Status", value: "contractStatus" },
        { text: "Item Status", value: "itemStatus" },

        { text: "Brand", value: "manufacturer" },
        { text: "Model", value: "model" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Machine Battery Voltage", value: "battery" },
        {
          text: "Estimated Battery Lifespan (days)",
          value: "estimatedBatteryLifespan",
        },

        { text: "DEF Level", value: "def" },
        { text: "Fuel Level", value: "fuel" },
        { text: "Payload Percentage", value: "payLoad" },
        { text: "Jobsite", value: "jobSite", width: "200px" },

        { text: "Description", value: "description", width: "500px" },
        { text: "Customer Jobsite", value: "customerJobsite" },

        { text: "Contractor", value: "contractor" },

        { text: "Start Date", value: "startDate" },

        { text: "End Date", value: "endDate" },
        {
          text: "Last Known Address",
          value: "lastKnownAddress",
          width: "200px",
        },
      ];
    }
    EventBus.$on("call-map", this.onCallMapRefresh);
    if (this.roles != "Customer") {
      this.getStats();
      this.viewMapWithoutFilter();
      this.getGroups();
      this.getBrands();
      this.getModels();
      this.getLocations();
      this.getZones();
      this.readContractsListFromApi();
    }
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setActiveToggleVal", 0);
    EventBus.$off("call-map", this.onCallMapReadCities);
    EventBus.$off("call-map", this.onCallMapRefresh);
  },
  methods: {
    onCallMapReadCities() {
      if (this.roles == "Customer") {
        this.readCities();
      }
    },
    onCallMapRefresh() {
      if (this.roles == "Customer") {
        this.getStats();
        this.viewMapWithoutFilter();
        this.getGroups();
        this.getBrands();
        this.getModels();
        this.getLocations();
        this.getZones();
        this.readContractsListFromApi();
      }
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },

    updatePlace(place) {
      this.searchFieldAddress = place.formatted_address;
      this.gotoAddressLocation();
    },
    async onToggleBtnChange() {
      this.$store.dispatch("setActiveToggleVal", this.toggle_exclusive_map);
      await this.readCities();
      if (this.searchFieldAddress != "") {
        await this.gotoAddressLocation();
      }
    },
    onToggleChange() {
      this.$store.dispatch(
        "setActiveContractsToggleVal",
        this.toggle_exclusive_contracts
      );
      this.readContractsListFromApi();
      this.contractsList.map((item) => {
        item.active = false;
        return item;
      });
    },
    filterData() {
      if (this.searchField) {
        this.isContractSearchFilter = true;
      } else {
        this.isContractSearchFilter = false;
      }
      if (this.searchStoreId) {
        this.storeIdFilter = true;
      } else {
        this.storeIdFilter = false;
      }
      if (this.searchContractId) {
        this.contractIdFilter = true;
      } else {
        this.contractIdFilter = false;
      }
      this.readCities();
    },
    handlePOI() {
      this.hidePOI = !this.hidePOI;
      if (this.hidePOI == false) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.setOptions({
            styles: [
              {
                featureType: "poi",
                stylers: [{ visibility: "on" }],
              },
              {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{ visibility: "on" }],
              },
            ],
          });
        });
      }
      if (this.hidePOI == true) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          map.setOptions({
            styles: [
              {
                featureType: "poi",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
              },
            ],
          });
        });
      }
    },
    handleHidingCustomGeofences(value) {
      this.hideCustomGeofences = value;
      if (this.hideCustomGeofences == false) {
        this.polygonsFiltered = this.polygons;
      }
      if (this.hideCustomGeofences == true || this.showGeofenceSearchFilters) {
        this.polygonsFiltered = this.polygons.filter((p) => p.editablePolygon);
      }
    },
    async getStats() {
      try {
        this.isStatsLoading = true;
        let statsResponse = await telematicsService.getStats();

        if (statsResponse.isSuccess && statsResponse.data) {
          if (this.permissions.includes("Customer Owned Equipment")) {
            this.statsData["customerOwned"] =
              statsResponse.data.customerOwnedEquipment;
          } else {
            this.statsData["customerOwned"] = 0;
          }
          if (this.permissions.includes("On Rent Equipment")) {
            if (this.roles == "Customer") {
              this.statsData["birchOwned"] =
                statsResponse.data.birchOwnedEquipmentOnRent;
            } else {
              statsResponse.data.birchOwnedEquipment;
            }
          } else {
            this.statsData["birchOwned"] = 0;
          }

          let tempcust = 0;
          let tempbirch = 0;
          if (this.permissions.includes("Customer Owned Equipment")) {
            tempcust = statsResponse.data.customerOwnedEquipment;
          }
          if (this.permissions.includes("On Rent Equipment")) {
            if (this.roles == "Customer") {
              tempbirch = statsResponse.data.birchOwnedEquipmentOnRent;
            } else {
              tempbirch = statsResponse.data.birchOwnedEquipment;
            }
          }
          this.statsData["birchOwned"] = tempbirch;
          this.statsData["total"] =
            this.roles == "Customer"
              ? tempbirch + tempcust
              : tempbirch + tempcust;

          this.series = [];
          this.telematics_series = [];
          this.series.push(statsResponse.data.itemsOverdueWithTelematics);
          this.telematics_series.push(
            this.roles == "Customer" ? tempbirch : tempbirch
          );
          if (this.permissions.includes("Customer Owned Equipment")) {
            this.telematics_series.push(tempcust);
          } else {
            this.telematics_series.push(0);
          }
          this.pageheaderKey = "pageheader" + String(Math.random() + 1);
          this.isStatsLoading = false;
          this.isStatsDataAvailable = true;
        } else {
          this.isStatsLoading = false;
          this.isStatsDataAvailable = false;
        }
      } catch (err) {
        this.isApplyFilter = false;
        this.isStatsLoading = false;
        this.isStatsDataAvailable = false;
        this.viewMapWithoutFilter();
        console.log(err);
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    resetOwnerType() {
      if (
        this.permissions.includes("Customer Owned Equipment") &&
        this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["1", "2"];
        this.selectedOwnershipFinal = "0";
      } else if (
        !this.permissions.includes("Customer Owned Equipment") &&
        this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["1"];
        this.selectedOwnershipFinal = "1";
      } else if (
        this.permissions.includes("Customer Owned Equipment") &&
        !this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["2"];
        this.selectedOwnershipFinal = "2";
      }
      this.readCities();
    },
    resetZone() {
      (this.selectedZone = []), this.readCities();
    },
    resetGroup() {
      (this.selectedGroup = []), this.readCities();
    },
    resetAsset() {
      (this.selectedAsset = ["CAN", "spot"]), (this.selectedAssetFinal = "");
      this.readCities();
    },
    resetBrand() {
      (this.selectedBrand = []), this.readCities();
    },
    resetRentalStatus() {
      (this.selectedRentalStatus = []),
        this.$router.replace(`/`).catch(() => {});
      this.readCities();
    },
    resetGPSReading() {
      (this.selectedGPSReading = []),
        this.gpsReadingList.map((item) => {
          item.disabled = false;
          return item;
        });
      this.readCities();
    },
    // Clears every alert/activity filter field. Shared by resetAlerts and resetAll.
    clearAlertFilters() {
      this.selectedAlert = "";
      this.selectedsubtype = "";
      this.lowDef = false;
      this.lowFuel = false;
      this.lowVoltage = false;
    },
    //Reset Alerts & Activity
    resetAlerts() {
      this.clearAlertFilters();
      this.readCities();
    },
    resetModel() {
      (this.selectedModel = []), this.readCities();
    },
    resetLocation() {
      (this.selectedLocation = []), this.readCities();
    },
    resetAll() {
      if (
        this.permissions.includes("Customer Owned Equipment") &&
        this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["1", "2"];
        this.selectedOwnershipFinal = "0";
      } else if (
        !this.permissions.includes("Customer Owned Equipment") &&
        this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["1"];
        this.selectedOwnershipFinal = "1";
      } else if (
        this.permissions.includes("Customer Owned Equipment") &&
        !this.permissions.includes("On Rent Equipment")
      ) {
        this.selectedOwnershipType = ["2"];
        this.selectedOwnershipFinal = "2";
      }

      this.selectedZone = [];
      this.selectedModel = [];
      this.selectedLocation = [];

      this.selectedBrand = [];
      this.selectedRentalStatus = [];
      this.selectedAsset = ["CAN", "spot"];
      this.selectedAssetFinal = "";
      this.selectedGroup = [];
      this.clearAlertFilters();
      this.selectedGPSReading = [];
      this.gpsReadingList.map((item) => {
        item.disabled = false;
        return item;
      });
      this.searchField = "";
      this.searchContractId = "";
      this.searchStoreId = "";
      this.searchFieldAddress = "";
      if (this.$route.query.searchkey) {
        this.$router.replace({ query: null });
      }
      if (this.$route.query.contractkey) {
        this.$router.replace({ query: null });
      }
      if (this.$route.query.storekey) {
        this.$router.replace({ query: null });
      }
      this.showReset = false;
      (this.selected = [
        "Status",
        "Asset Type",
        "Brand",
        "Rental Status",
        "Model",
        "Geofence",
        "Group",
        "Type",
        "Alerts",
        "GPS Reading",
        "Jobsite",
      ]),
        this.$router.replace(`/`).catch(() => {});
      this.readCities();
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getBrands() {
      try {
        let response = await telematicsService.getBrands();
        if (response) {
          this.brands = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              brand: String(index),
            };
          });

        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    viewMapWithoutFilter() {
      this.mapColValue = "10";
      this.filterDialog = false;
    },
    onModelChange() {
      if (this.selectedModel.length > 0) {
        this.isModelFilter = true;
      } else {
        this.isModelFilter = false;
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },

    OnOwnerTypeChange() {
      if (this.selectedOwnershipType.length == 0) {
        this.selectedOwnershipFinal = "0";
        this.isOwnerFilter = true;
      } else if (this.selectedOwnershipType == 1) {
        this.isOwnerFilter = true;
        this.selectedOwnershipFinal = this.selectedOwnershipType[0];
      } else {
        this.isOwnerFilter = false;
        this.selectedOwnershipFinal = "0";
      }
      if (
        (this.selectedOwnershipType.length == 0) |
        (this.selectedOwnershipType.length == 2)
      ) {
        this.selectedOwnershipFinal = "0";
      } else {
        this.selectedOwnershipFinal = this.selectedOwnershipType[0];
      }
    },
    OnSubTypeChange() {
      if (this.selectedsubtype == "" || this.selectedsubtype == null) {
        (this.lowFuel = false),
          (this.lowDef = false),
          (this.lowVoltage = false);
        this.isSubTypeFilter = false;
      }
      if (this.selectedsubtype == "lowFuel") {
        this.lowFuel = true;
        this.lowDef = false;
        this.lowVoltage = false;
        this.isSubTypeFilter = true;
      }
      if (this.selectedsubtype == "lowDef") {
        this.lowDef = true;
        this.lowFuel = false;
        this.lowVoltage = false;
        this.isSubTypeFilter = true;
      }
      if (this.selectedsubtype == "lowVoltage") {
        this.lowVoltage = true;
        this.lowFuel = false;
        this.lowDef = false;
        this.isSubTypeFilter = true;
      }
    },
    onGPSChange() {
      if (this.selectedGPSReading.length > 0) {
        this.isLastGPSReadingFilter = true;
      } else {
        this.isLastGPSReadingFilter = false;
      }
      let checkValue = this.selectedGPSReading.includes("0");
      if (checkValue) {
        this.selectedGPSReading = ["0"];
        this.gpsReadingList.forEach((item) => {
          if (item.value != "0") {
            item.disabled = true;
          }
        });
      } else {
        this.gpsReadingList.map((item) => {
          item.disabled = false;
          return item;
        });
      }
    },
    onAssetChange() {
      if (this.selectedAsset.length == 0) {
        this.isAssetFilter = true;
        this.selectedAssetFinal = "";
      } else if (this.selectedAsset.length == 1) {
        this.isAssetFilter = true;
        this.selectedAssetFinal = this.selectedAsset[0];
      } else {
        this.selectedAssetFinal = "";
        this.isAssetFilter = false;
      }
      if (this.selectedAsset == "" || this.selectedAsset.length == 2) {
        this.selectedAssetFinal = "";
      } else {
        this.selectedAssetFinal = this.selectedAsset[0];
      }
    },
    onGroupChange() {
      if (this.selectedGroup.length > 0) {
        this.isGroupFilter = true;
      } else {
        this.isGroupFilter = false;
      }
    },
    onBrandChange() {
      if (this.selectedBrand.length > 0) {
        this.isBrandFilter = true;
      } else {
        this.isBrandFilter = false;
      }
    },
    // Read cities or Lat/Lng from Api
    async readCities() {
      this.getGeofences();
      //Owner Type Filter
      if (
        this.selectedOwnershipType.length == 1
      ) {
        this.isOwnerFilter = true;
        let tempOwner = this.selectedOwnershipType.join(",");
        this.ownerTypeQuery = {
          ownerTypeValue: tempOwner,
          ownerFinalValue: this.selectedOwnershipFinal,
          isOwnerFilter: this.isOwnerFilter,
        };
      } else {
        this.isOwnerFilter = false;
        this.ownerTypeQuery = {};
      }
      //Asset Type Filter
      if (this.selectedAsset.length == 0 || this.selectedAsset.length == 1) {
        this.isAssetFilter = true;
        let tempAsset = this.selectedAsset.join(",");
        this.assetTypeQuery = {
          assetValue: tempAsset,
          assetFinalValue: this.selectedAssetFinal,
          isAssetFilter: this.isAssetFilter,
        };
      } else {
        this.isAssetFilter = false;
        this.assetTypeQuery = {};
      }
      //Brand Filter
      if (this.selectedBrand.length > 0) {
        this.isBrandFilter = true;
        let tempBrand = this.selectedBrand.join(",");
        this.brandQuery = {
          brandValue: tempBrand,
          isBrandFilter: this.isBrandFilter,
        };
      } else {
        this.isBrandFilter = false;
        this.brandQuery = {};
      }
      //Rental Status Filter
      if (
        this.selectedRentalStatus.length > 0 &&
        (this.selectedOwnershipType[0] == "1" ||
          this.selectedOwnershipType[1] == "1")
      ) {
        this.isRentalStatusFilter = true;
        this.rentalQuery = {
          rentalValue: this.selectedRentalStatus.join(","),
          isRentalStatusFilter: this.isRentalStatusFilter,
        };
      } else {
        this.rentalQuery = {};
        this.isRentalStatusFilter = false;
      }
      // Model FIlter
      if (this.selectedModel.length > 0) {
        this.isModelFilter = true;
        let tempModel = this.selectedModel.join(",");
        this.modelQuery = {
          modelValue: tempModel,
          isModelFilter: this.isModelFilter,
        };
      } else {
        this.isModelFilter = false;
        this.modelQuery = {};
      }
      //Group Filter
      if (this.selectedGroup.length > 0) {
        this.isGroupFilter = true;
        let tempGroup = this.selectedGroup.join(",");
        this.groupQuery = {
          groupValue: tempGroup,
          isGroupFilter: this.isGroupFilter,
        };
      } else {
        this.isGroupFilter = false;
        this.groupQuery = {};
      }
      if (this.selectedZone.length > 0) {
        this.isZoneFilter = true;
        let tempZone = this.selectedZone.join(",");
        this.zoneQuery = {
          geofenceValue: tempZone,
          isZoneFilter: this.isZoneFilter,
        };
      } else {
        this.isZoneFilter = false;
        this.zoneQuery = {};
      }
      //Type Filter
      //subType Filter
      if (this.selectedsubtype) {
        this.isSubTypeFilter = true;
        this.subTypeQuery = {
          subTypeValue: this.selectedsubtype,
          lowVoltage: this.lowVoltage,
          lowDef: this.lowDef,
          lowFuel: this.lowFuel,
          isSubTypeFilter: this.isSubTypeFilter,
        };
      } else {
        this.isSubTypeFilter = false;
        this.subTypeQuery = {};
      }
      //Alerts Filter
      if (this.selectedAlert) {
        this.isAlertsFilter = true;
        this.alertsQuery = {
          alertValue: this.selectedAlert,
          isAlertsFilter: this.isAlertsFilter,
        };
      } else {
        this.isAlertsFilter = false;
        this.alertsQuery = {};
      }
      //Activity Filter

      //Last GPS Reading Filter
      if (this.selectedGPSReading.length > 0) {
        this.isLastGPSReadingFilter = true;
        let tempGPSReading = this.selectedGPSReading.join(",");
        this.GPSReadingQuery = {
          gpsReadingValue: tempGPSReading,
          isLastGPSReadingFilter: this.isLastGPSReadingFilter,
        };
      } else {
        this.GPSReadingQuery = {};
        this.isLastGPSReadingFilter = false;
      }
      //Location Filter
      if (this.selectedLocation.length > 0) {
        this.isLocationFilter = true;
        let tempJobsites = this.selectedLocation.join(",");
        this.locationQuery = {
          locationValue: tempJobsites,
          isLocationFilter: this.isLocationFilter,
        };
      } else {
        this.isLocationFilter = false;
        this.locationQuery = {};
      }
      //Search Field Filter
      if (this.searchField) {
        this.isContractSearchFilter = true;
        this.searchFieldQuery = {
          searchFieldValue: this.searchField,
          isContractSearchFilter: this.isContractSearchFilter,
        };
      } else {
        this.isContractSearchFilter = false;
        this.searchFieldQuery = {};
      }
      if (this.searchContractId) {
        this.contractIdFilter = true;
        this.searchContractFieldQuery = {
          searchContractFieldValue: this.searchContractId,
          contractIdFilter: this.contractIdFilter,
        };
      } else {
        this.contractIdFilter = false;
        this.searchContractFieldQuery = {};
      }
      if (this.searchStoreId) {
        this.storeIdFilter = true;
        this.searchStoreFieldQuery = {
          searchStoreFieldValue: this.searchStoreId,
          storeIdFilter: this.storeIdFilter,
        };
      } else {
        this.storeIdFilter = false;
        this.searchStoreFieldQuery = {};
      }

      //Address Search Filter
      //Final Router Query Obj
      this.finalRouteQuery = this.buildFilterQuery();
      this.$router
        .replace({ path: "/", query: this.finalRouteQuery })
        .catch(() => {});
      this.isApplyFilter = true;
      if (this.roles == "Customer") {
        if (
          this.companyIdDropdown == 7620 ||
          this.companyIdDropdown == 5704 ||
          this.companyIdDropdown == 1540
        ) {
          this.header_map = [
            { text: "Map", value: "map" },
            { text: "Equipment #", value: "stockKey", width: "200px" },
            { text: "Equipment Name", value: "name", width: "200px" },
            { text: "Customer Name", value: "customerName", width: "200px" },
            { text: "Contract#", value: "contractId", width: "200px" },

            { text: "Date Out", value: "contractStartDate" },
            { text: "Estimated Return Date", value: "contractEndDate" },
            { text: "Rental/Asset", value: "isCustomerOwned" },
            { text: "Asset Type", value: "assetType" },
            { text: "Rental Status", value: "contractStatus" },
            { text: "Item Status", value: "itemStatus" },

            { text: "Brand", value: "manufacturer" },
            { text: "Model", value: "model" },
            { text: "Telematics SN", value: "tuSerialNumber" },
            { text: "Machine Battery Voltage", value: "battery" },
            { text: "DEF Level", value: "def" },
            { text: "Fuel Level", value: "fuel" },
            { text: "Payload Percentage", value: "payLoad" },
            { text: "Jobsite", value: "jobSite", width: "200px" },

            { text: "Description", value: "description", width: "500px" },

            { text: "Contractor", value: "contractor" },

            { text: "Start Date", value: "startDate" },

            { text: "End Date", value: "endDate" },
            {
              text: "Last Known Address",
              value: "lastKnownAddress",
              width: "200px",
            },
          ];
        } else {
          this.header_map = [
            { text: "Map", value: "map" },
            { text: "Equipment #", value: "stockKey", width: "200px" },
            { text: "Equipment Name", value: "name", width: "200px" },
            { text: "Customer Name", value: "customerName", width: "200px" },
            { text: "Contract#", value: "contractId", width: "200px" },

            { text: "Date Out", value: "contractStartDate" },
            { text: "Estimated Return Date", value: "contractEndDate" },
            { text: "Rental/Asset", value: "isCustomerOwned" },
            { text: "Asset Type", value: "assetType" },
            { text: "Rental Status", value: "contractStatus" },
            { text: "Item Status", value: "itemStatus" },

            { text: "Brand", value: "manufacturer" },
            { text: "Model", value: "model" },
            { text: "Telematics SN", value: "tuSerialNumber" },
            { text: "Machine Battery Voltage", value: "battery" },
            { text: "DEF Level", value: "def" },
            { text: "Fuel Level", value: "fuel" },
            { text: "Payload Percentage", value: "payLoad" },
            { text: "Jobsite", value: "jobSite", width: "200px" },

            {
              text: "Last Known Address",
              value: "lastKnownAddress",
              width: "200px",
            },
          ];
        }
      } else {
        this.header_map = [
          { text: "Map", value: "map" },
          { text: "Equipment #", value: "stockKey", width: "200px" },
          { text: "Equipment Name", value: "name", width: "200px" },
          { text: "Customer Name", value: "customerName", width: "200px" },
          { text: "Contract#", value: "contractId", width: "200px" },

          { text: "Date Out", value: "contractStartDate" },
          { text: "Estimated Return Date", value: "contractEndDate" },
          { text: "Rental/Asset", value: "isCustomerOwned" },
          { text: "Asset Type", value: "assetType" },
          { text: "Rental Status", value: "contractStatus" },
          { text: "Item Status", value: "itemStatus" },

          { text: "Brand", value: "manufacturer" },
          { text: "Model", value: "model" },
          { text: "Telematics SN", value: "tuSerialNumber" },
          { text: "Machine Battery Voltage", value: "battery" },
          {
            text: "Estimated Battery Lifespan (days)",
            value: "estimatedBatteryLifespan",
          },
          { text: "DEF Level", value: "def" },
          { text: "Fuel Level", value: "fuel" },
          { text: "Payload Percentage", value: "payLoad" },
          { text: "Jobsite", value: "jobSite", width: "200px" },

          { text: "Description", value: "description", width: "500px" },
          { text: "Customer Jobsite", value: "customerJobsite" },

          { text: "Contractor", value: "contractor" },

          { text: "Start Date", value: "startDate" },

          { text: "End Date", value: "endDate" },
          {
            text: "Last Known Address",
            value: "lastKnownAddress",
            width: "200px",
          },
        ];
      }
      this.infowindowdiv = false;
      this.excelList = [];
      //handle checkbox change

      let listsearch = "";
      if (this.searchFieldAddress && this.toggle_exclusive_map == 1) {
        listsearch = this.searchFieldAddress;
      } else {
        listsearch = "";
      }
      let decodedsearc;
      if (
        this.$route.query &&
        this.$route.query.isContractSearchFilter &&
        this.$route.query.searchFieldValue.includes("%23")
      ) {
        decodedsearc = decodeURIComponent(this.$route.query.searchFieldValue);
      } else {
        decodedsearc = encodeURIComponent(this.$route.query.searchFieldValue);
      }
      let decodedstoresearc;
      if (
        this.$route.query &&
        this.$route.query.storeIdFilter &&
        this.$route.query.searchStoreFieldValue.includes("%23")
      ) {
        decodedstoresearc = decodeURIComponent(
          this.$route.query.searchStoreFieldValue
        );
      } else {
        decodedstoresearc = encodeURIComponent(
          this.$route.query.searchStoreFieldValue
        );
      }
      try {
        let mapResponse = await telematicsService.getMapEquipmentsList(
          Number(this.selectedOwnershipFinal),
          this.searchField ? decodedsearc : "", // encoding special characters using encodeURIComponent
          this.searchContractId,
          this.searchStoreId ? decodedstoresearc : "",
          this.selectedAssetFinal,
          this.selectedBrand.join(","),
          this.selectedModel.join(","),
          this.selectedZone.join(","),
          this.selectedGroup.join(","),
          this.selectedAlert,
          this.selectedGPSReading.join(","),
          this.selectedLocation.join(","),
          this.selectedRentalStatus.join(","),
          listsearch,
          this.lowDef,
          this.lowFuel,
          this.lowVoltage
        );
        if (mapResponse.isSuccess) {
          this.actualLocationsFromAPi = mapResponse.data.length;
          this.viewMapWithoutFilter();
          let locations = mapResponse.data.filter(
            (x) =>
              x.lastLocation != null &&
              x.lastLocation.lat != null &&
              x.lastLocation.lng != null &&
              !(x.lastLocation.lat == 0 && x.lastLocation.lng == 0)
          );
          this.locationsFiltered = locations.length;
          this.actualEquipmentsCount =
            parseInt(this.actualLocationsFromAPi) - this.locationsFiltered;
          this.markers = locations;

          if (this.markers.length == 0) {
            this.center = { lat: 56.58, lng: -115.2 };
            this.zoom = 4.6;
          } else if (this.markers.length == 1) {
            this.center = this.markers[0].lastLocation;
            this.zoom = 17;
          } else {
            this.center = this.markers[0].lastLocation;
            this.zoom = 4.6;
          }
          let removeDuplicate = {};
          this.markers.map((item, index) => {
            item.map = "";
            if (item.isCustomerOwned) {
              item.colorCheck = "black-bg";
            } else {
              item.colorCheck = "red-bg";
            }
            //check if there is any duplicate lat lng for 2 different assets and if there are any then slightly adjust the lat and lng
            // of the marker
            let duplicateLatItems = this.markers.filter(
              (markerItem, markIndex) => {
                return (
                  item.lastLocation.lat == markerItem.lastLocation.lat &&
                  item.lastLocation.lng == markerItem.lastLocation.lng &&
                  index != markIndex
                );
              }
            );

            if (duplicateLatItems.length > 0) {
              if (
                removeDuplicate[
                  item.lastLocation.lat + "_" + item.lastLocation.lng
                ]
              ) {
                removeDuplicate[
                  item.lastLocation.lat + "_" + item.lastLocation.lng
                ] =
                  removeDuplicate[
                    item.lastLocation.lat + "_" + item.lastLocation.lng
                  ] + 0.0001;
              } else {
                removeDuplicate[
                  item.lastLocation.lat + "_" + item.lastLocation.lng
                ] = 0.0001;
              }

              //updating both the latitude and longitude of duplicate item
              item.lastLocation.lng =
                item.lastLocation.lng +
                removeDuplicate[
                  item.lastLocation.lat + "_" + item.lastLocation.lng
                ];
            }

            return item;
          });
          this.markerDataTable = [...this.markers];
          if (this.roles == "Admin" || this.roles == "Birch User") {
            for (let r = 0; r < this.markers.length; r++) {
              if (this.markers[r].rentalDetails.length > 0) {
                for (let d = 0; d < this.markers[r].rentalDetails.length; d++) {
                  this.markers[r].rentalDetails[d]["stockKey"] =
                    this.markers[r].stockKey;
                  this.markers[r].rentalDetails[d]["assetId"] =
                    this.markers[r].assetId;
                  this.markers[r].rentalDetails[d]["name"] =
                    this.markers[r].name;
                  this.markers[r].rentalDetails[d]["tuName"] =
                    this.markers[r].tuName;

                  this.markers[r].rentalDetails[d]["isCustomerOwned"] =
                    this.markers[r].isCustomerOwned;
                  this.markers[r].rentalDetails[d]["assetType"] =
                    this.markers[r].assetType;
                  this.markers[r].rentalDetails[d]["colorCheck"] =
                    this.markers[r].colorCheck;
                  this.markers[r].rentalDetails[d]["itemStatus"] =
                    this.markers[r].itemStatus;
                  this.markers[r].rentalDetails[d]["manufacturer"] =
                    this.markers[r].manufacturer;
                  this.markers[r].rentalDetails[d]["model"] =
                    this.markers[r].model;
                  this.markers[r].rentalDetails[d]["tuSerialNumber"] =
                    this.markers[r].tuSerialNumber;
                  this.markers[r].rentalDetails[d]["battery"] =
                    this.markers[r].battery;
                  this.markers[r].rentalDetails[d]["def"] = this.markers[r].def;
                  this.markers[r].rentalDetails[d]["fuel"] =
                    this.markers[r].fuel;
                  this.markers[r].rentalDetails[d]["payLoad"] =
                    this.markers[r].payLoad;
                  this.markers[r].rentalDetails[d]["estimatedBatteryLifespan"] =
                    this.markers[r].estimatedBatteryLifespan != null
                      ? this.markers[r].estimatedBatteryLifespan
                      : "N/A";
                  this.markers[r].rentalDetails[d]["jobSite"] =
                    this.markers[r].jobSite;

                  this.markers[r].rentalDetails[d]["contractor"] =
                    this.markers[r].contractor;
                  this.markers[r].rentalDetails[d]["startDate"] =
                    this.markers[r].startDate;
                  this.markers[r].rentalDetails[d]["endDate"] =
                    this.markers[r].endDate;
                  this.markers[r].rentalDetails[d]["customerEquipmentName"] =
                    this.markers[r].customerEquipmentName;
                  this.markers[r].rentalDetails[d]["description"] =
                    this.markers[r].description;
                  this.markers[r].rentalDetails[d]["customerJobsite"] =
                    this.markers[r].customerJobsite;
                  this.markers[r].rentalDetails[d]["lastKnownAddress"] =
                    this.markers[r].lastKnownAddress;
                }
              }
            }
            this.rentalDetailsList = this.markers
              .map((e) => e.rentalDetails)
              .flat();
            this.excelList = this.rentalDetailsList.map((item) => {
              return {
                name: item.isCustomerOwned
                  ? item.customerEquipmentName
                    ? item.customerEquipmentName
                    : ""
                  : item.name
                  ? item.name
                  : "",
                contractId: item.isCustomerOwned
                  ? "N/A"
                  : item.contractId
                  ? item.contractId
                  : "",
                stockKey: item.stockKey ? item.stockKey : item.tuName,
                customerName: item.customerName ? item.customerName : "",
                isRental: item.isCustomerOwned ? "Asset" : "Rental",
                tuSerialNumber: item.tuSerialNumber ? item.tuSerialNumber : "",
                assetType: item.assetType ? item.assetType : "",
                manufacturer: item.manufacturer ? item.manufacturer : "",
                model: item.model ? item.model : "",
                batteryVoltage:
                  item.assetType && item.assetType.startsWith("SPOT")
                    ? "N/A"
                    : item.battery &&
                      (item.battery.batteryVoltage ||
                        item.battery.batteryVoltage === 0)
                    ? item.battery.batteryVoltage + "V"
                    : "",
                defLevel:
                  item.def && (item.def.percent || item.def.percent === 0)
                    ? item.def.percent
                    : "",
                fuelLevel:
                  item.fuel && (item.fuel.percent || item.fuel.percent === 0)
                    ? item.fuel.percent
                    : "",
                payloadPercentage:
                  item.payLoad &&
                  (item.payLoad.percentage || item.payLoad.percentage === 0)
                    ? item.payLoad.percentage
                    : "",

                jobSite: item.isCustomerOwned
                  ? "N/A"
                  : item.jobSite
                  ? item.jobSite
                  : "",

                estimatedBatteryLifespan:
                  item.estimatedBatteryLifespan != null
                    ? item.estimatedBatteryLifespan
                    : "N/A",
                contractStatus: item.isCustomerOwned
                  ? "N/A"
                  : item.contractStatus
                  ? item.contractStatus
                  : "",
                itemStatus: item.isCustomerOwned
                  ? "N/A"
                  : item.itemStatus
                  ? item.itemStatus
                  : "",
                contractor: item.isCustomerOwned
                  ? item.contractor
                    ? item.contractor
                    : ""
                  : "N/A",
                startDate: item.isCustomerOwned
                  ? item.startDate
                    ? item.startDate.split("T")[0]
                    : ""
                  : "N/A",
                endDate: item.isCustomerOwned
                  ? item.endDate
                    ? item.endDate.split("T")[0]
                    : ""
                  : "N/A",
                contractStartDate: item.isCustomerOwned
                  ? "N/A"
                  : item.contractStartDate
                  ? moment(item.contractStartDate.split("T")[0]).format("L")
                  : "",
                contractEndDate: item.isCustomerOwned
                  ? "N/A"
                  : item.contractEndDate
                  ? moment(item.contractEndDate.split("T")[0]).format("L")
                  : "",
                description: item.isCustomerOwned
                  ? item.description
                    ? item.description
                    : ""
                  : "N/A",
                customerJobsite: item.isCustomerOwned
                  ? item.customerJobsite
                    ? item.customerJobsite
                    : ""
                  : "N/A",
                lastKnownAddress: item.lastKnownAddress
                  ? item.lastKnownAddress
                  : "",
              };
            });
          } else {
            if (
              this.permissions.includes("Customer Owned Equipment") &&
              this.permissions.includes("On Rent Equipment")
            ) {
              this.rentalDetailsList = this.markers;
              this.excelList = locations.map((item) => {
                return {
                  name: item.isCustomerOwned
                    ? item.customerEquipmentName
                      ? item.customerEquipmentName
                      : ""
                    : item.name
                    ? item.name
                    : "",
                  contractId: item.isCustomerOwned
                    ? "N/A"
                    : item.contractId
                    ? item.contractId + "-" + item.depotId
                    : "",
                  contractStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStatus
                    ? item.contractStatus
                    : "",
                  itemStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.itemStatus
                    ? item.itemStatus
                    : "",
                  tuSerialNumber: item.tuSerialNumber
                    ? item.tuSerialNumber
                    : "",

                  stockKey: item.stockKey ? item.stockKey : item.tuName,
                  customerName: item.customerName ? item.customerName : "",
                  isRental: item.isCustomerOwned ? "Asset" : "Rental",
                  serialNumber: item.serialNumber ? item.serialNumber : "",
                  assetType: item.assetType ? item.assetType : "",
                  manufacturer: item.manufacturer ? item.manufacturer : "",
                  model: item.model ? item.model : "",
                  batteryVoltage:
                    item.assetType && item.assetType.startsWith("SPOT")
                      ? "N/A"
                      : item.battery &&
                        (item.battery.batteryVoltage ||
                          item.battery.batteryVoltage === 0)
                      ? item.battery.batteryVoltage + "V"
                      : "",
                  defLevel:
                    item.def && (item.def.percent || item.def.percent === 0)
                      ? item.def.percent
                      : "",
                  fuelLevel:
                    item.fuel && (item.fuel.percent || item.fuel.percent === 0)
                      ? item.fuel.percent
                      : "",
                  payloadPercentage:
                    item.payLoad &&
                    (item.payLoad.percentage || item.payLoad.percentage === 0)
                      ? item.payLoad.percentage
                      : "",
                  jobSite: item.isCustomerOwned
                    ? "N/A"
                    : item.jobSite
                    ? item.jobSite
                    : "",
                  lastKnownAddress: item.lastKnownAddress
                    ? item.lastKnownAddress
                    : "",
                  contractor: item.isCustomerOwned
                    ? item.contractor
                      ? item.contractor
                      : ""
                    : "N/A",
                  startDate: item.isCustomerOwned
                    ? item.startDate
                      ? item.startDate.split("T")[0]
                      : ""
                    : "N/A",
                  endDate: item.isCustomerOwned
                    ? item.endDate
                      ? item.endDate.split("T")[0]
                      : ""
                    : "N/A",
                  contractStartDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStartDate
                    ? moment(item.contractStartDate.split("T")[0]).format("L")
                    : "",
                  contractEndDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractEndDate
                    ? moment(item.contractEndDate.split("T")[0]).format("L")
                    : "",
                  description: item.isCustomerOwned
                    ? item.description
                      ? item.description
                      : ""
                    : "N/A",
                  customerJobsite: item.isCustomerOwned
                    ? item.customerJobsite
                      ? item.customerJobsite
                      : ""
                    : "N/A",
                };
              });
            } else if (
              !this.permissions.includes("Customer Owned Equipment") &&
              this.permissions.includes("On Rent Equipment")
            ) {
              this.rentalDetailsList = this.markers.filter(
                (e) => e.isCustomerOwned == false
              );
              locations = locations.filter((e) => e.isCustomerOwned == false);
              this.excelList = locations.map((item) => {
                return {
                  name: item.isCustomerOwned
                    ? item.customerEquipmentName
                      ? item.customerEquipmentName
                      : ""
                    : item.name
                    ? item.name
                    : "",
                  contractId: item.isCustomerOwned
                    ? "N/A"
                    : item.contractId
                    ? item.contractId + "-" + item.depotId
                    : "",
                  contractStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStatus
                    ? item.contractStatus
                    : "",
                  itemStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.itemStatus
                    ? item.itemStatus
                    : "",
                  tuSerialNumber: item.tuSerialNumber
                    ? item.tuSerialNumber
                    : "",
                  stockKey: item.stockKey ? item.stockKey : item.tuName,
                  customerName: item.customerName ? item.customerName : "",
                  isRental: item.isCustomerOwned ? "Asset" : "Rental",
                  serialNumber: item.serialNumber ? item.serialNumber : "",
                  assetType: item.assetType ? item.assetType : "",
                  manufacturer: item.manufacturer ? item.manufacturer : "",
                  model: item.model ? item.model : "",
                  batteryVoltage:
                    item.assetType && item.assetType.startsWith("SPOT")
                      ? "N/A"
                      : item.battery &&
                        (item.battery.batteryVoltage ||
                          item.battery.batteryVoltage === 0)
                      ? item.battery.batteryVoltage + "V"
                      : "",
                  defLevel:
                    item.def && (item.def.percent || item.def.percent === 0)
                      ? item.def.percent
                      : "",
                  fuelLevel:
                    item.fuel && (item.fuel.percent || item.fuel.percent === 0)
                      ? item.fuel.percent
                      : "",
                  payloadPercentage:
                    item.payLoad &&
                    (item.payLoad.percentage || item.payLoad.percentage === 0)
                      ? item.payLoad.percentage
                      : "",
                  jobSite: item.isCustomerOwned
                    ? "N/A"
                    : item.jobSite
                    ? item.jobSite
                    : "",
                  lastKnownAddress: item.lastKnownAddress
                    ? item.lastKnownAddress
                    : "",
                  contractor: item.isCustomerOwned
                    ? item.contractor
                      ? item.contractor
                      : ""
                    : "N/A",
                  startDate: item.isCustomerOwned
                    ? item.startDate
                      ? item.startDate.split("T")[0]
                      : ""
                    : "N/A",
                  endDate: item.isCustomerOwned
                    ? item.endDate
                      ? item.endDate.split("T")[0]
                      : ""
                    : "N/A",
                  contractStartDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStartDate
                    ? moment(item.contractStartDate.split("T")[0]).format("L")
                    : "",
                  contractEndDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractEndDate
                    ? moment(item.contractEndDate.split("T")[0]).format("L")
                    : "",
                  description: item.isCustomerOwned
                    ? item.description
                      ? item.description
                      : ""
                    : "N/A",
                  customerJobsite: item.isCustomerOwned
                    ? item.customerJobsite
                      ? item.customerJobsite
                      : ""
                    : "N/A",
                };
              });
            } else if (
              this.permissions.includes("Customer Owned Equipment") &&
              !this.permissions.includes("On Rent Equipment")
            ) {
              this.rentalDetailsList = this.markers.filter(
                (e) => e.isCustomerOwned
              );
              locations = locations.filter((e) => e.isCustomerOwned);
              this.excelList = locations.map((item) => {
                return {
                  name: item.isCustomerOwned
                    ? item.customerEquipmentName
                      ? item.customerEquipmentName
                      : ""
                    : item.name
                    ? item.name
                    : "",
                  contractId: item.isCustomerOwned
                    ? "N/A"
                    : item.contractId
                    ? item.contractId + "-" + item.depotId
                    : "",
                  contractStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStatus
                    ? item.contractStatus
                    : "",
                  itemStatus: item.isCustomerOwned
                    ? "N/A"
                    : item.itemStatus
                    ? item.itemStatus
                    : "",
                  tuSerialNumber: item.tuSerialNumber
                    ? item.tuSerialNumber
                    : "",
                  stockKey: item.stockKey ? item.stockKey : item.tuName,
                  customerName: item.customerName ? item.customerName : "",
                  isRental: item.isCustomerOwned ? "Asset" : "Rental",
                  serialNumber: item.serialNumber ? item.serialNumber : "",
                  assetType: item.assetType ? item.assetType : "",
                  manufacturer: item.manufacturer ? item.manufacturer : "",
                  model: item.model ? item.model : "",
                  batteryVoltage:
                    item.assetType && item.assetType.startsWith("SPOT")
                      ? "N/A"
                      : item.battery &&
                        (item.battery.batteryVoltage ||
                          item.battery.batteryVoltage === 0)
                      ? item.battery.batteryVoltage + "V"
                      : "",
                  defLevel:
                    item.def && (item.def.percent || item.def.percent === 0)
                      ? item.def.percent
                      : "",
                  fuelLevel:
                    item.fuel && (item.fuel.percent || item.fuel.percent === 0)
                      ? item.fuel.percent
                      : "",
                  payloadPercentage:
                    item.payLoad &&
                    (item.payLoad.percentage || item.payLoad.percentage === 0)
                      ? item.payLoad.percentage
                      : "",
                  jobSite: item.isCustomerOwned
                    ? "N/A"
                    : item.jobSite
                    ? item.jobSite
                    : "",
                  lastKnownAddress: item.lastKnownAddress
                    ? item.lastKnownAddress
                    : "",
                  contractor: item.isCustomerOwned
                    ? item.contractor
                      ? item.contractor
                      : ""
                    : "N/A",
                  startDate: item.isCustomerOwned
                    ? item.startDate
                      ? item.startDate.split("T")[0]
                      : ""
                    : "N/A",
                  endDate: item.isCustomerOwned
                    ? item.endDate
                      ? item.endDate.split("T")[0]
                      : ""
                    : "N/A",
                  contractStartDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractStartDate
                    ? moment(item.contractStartDate.split("T")[0]).format("L")
                    : "",
                  contractEndDate: item.isCustomerOwned
                    ? "N/A"
                    : item.contractEndDate
                    ? moment(item.contractEndDate.split("T")[0]).format("L")
                    : "",
                  description: item.isCustomerOwned
                    ? item.description
                      ? item.description
                      : ""
                    : "N/A",
                  customerJobsite: item.isCustomerOwned
                    ? item.customerJobsite
                      ? item.customerJobsite
                      : ""
                    : "N/A",
                };
              });
            }
          }
          this.getCurrentZoom(this.zoom);
          this.isApplyFilter = false;
        } else {
          if (!this.center.lat || !this.center.lng) {
            this.center = { lat: 56.58, lng: -115.2 };
          }
          this.viewMapWithoutFilter();
          this.markers = [];
          this.rentalDetailsList = [];
          this.zoom = 4.6;
          this.getCurrentZoom(this.zoom);
          this.isApplyFilter = false;
        }
      } catch (err) {
        if (!this.center.lat || !this.center.lng) {
          this.center = { lat: 56.58, lng: -115.2 };
        }
        this.viewMapWithoutFilter();
        this.markers = [];
        this.rentalDetailsList = [];

        this.zoom = 4.6;
        this.getCurrentZoom(this.zoom);
        this.isApplyFilter = false;
        console.log(err);
      }
    },
    // BE-1117: battery/def/fuel/payLoad hold objects that Vuetify's default sort
    // compares as equal text (vuetify/lib/util/helpers.js:293, v2.7.2), so those columns sort by the number their cell shows
    // (same rule as the cell templates and Excel export; no number sorts lowest).
    sortRentalDetailsList(items, sortBy, sortDesc, locale, customSorters) {
      const shownNumbers = {
        battery: (item) =>
          item.assetType && item.assetType.startsWith("SPOT")
            ? null
            : item.battery &&
              (item.battery.batteryVoltage ||
                item.battery.batteryVoltage === 0)
            ? item.battery.batteryVoltage
            : null,
        def: (item) =>
          item.def && (item.def.percent || item.def.percent === 0)
            ? item.def.percent
            : null,
        fuel: (item) =>
          item.fuel && (item.fuel.percent || item.fuel.percent === 0)
            ? item.fuel.percent
            : null,
        payLoad: (item) =>
          item.payLoad &&
          (item.payLoad.percentage || item.payLoad.percentage === 0)
            ? item.payLoad.percentage
            : null,
      };
      const shownNumber = shownNumbers[sortBy[0]];
      if (!shownNumber) {
        return sortItems(items, sortBy, sortDesc, locale, customSorters);
      }
      return items.sort((a, b) => {
        let numberA = shownNumber(a);
        let numberB = shownNumber(b);
        if (sortDesc[0]) {
          [numberA, numberB] = [numberB, numberA];
        }
        if (numberA === null) {
          return numberB === null ? 0 : -1;
        }
        if (numberB === null) {
          return 1;
        }
        return numberA - numberB;
      });
    },
    exportTableData() {
      this.excelHeader = [];
      this.startrow = 3;
      this.excelHeader.push(["Equipment Data"]);

      this.startrow += 1;
      let cust;
      if (this.companyNameDropdown == "") {
        cust = "All";
      } else {
        cust = this.$store.getters.companyNameDropdown;
      }
      this.excelHeader.push(["Customer:" + " " + cust]);

      // One header row per active filter, in this exact order. Conditions are read here
      // because nothing between them changes state; the label is built only when used.
      const filterHeaderRows = [
        [this.selectedOwnershipFinal == "1", () => "Type: Birch Owned"],
        [this.selectedOwnershipFinal == "2", () => "Type: Customer Owned"],
        [
          this.selectedOwnershipFinal == "0",
          () => "Type: Birch and Customer Owned",
        ],
        [this.searchField, () => "Equipment #/Serial#" + this.searchField],
        [this.searchContractId, () => "Contract:" + this.searchContractId],
        [this.searchStoreId, () => "Store:" + this.searchStoreId],
        [this.searchFieldAddress, () => "Address:" + this.searchFieldAddress],
        [
          this.selectedAsset.length > 0,
          () => "Asset Type: " + this.selectedAsset,
        ],
        [
          this.selectedBrand.length > 0,
          () => "Brand: " + this.selectedBrand.join(","),
        ],
        [
          this.selectedRentalStatus.length > 0,
          () => "Rental Status: " + this.selectedRentalStatus.join(","),
        ],
        [
          this.selectedModel.length > 0,
          () => "Model: " + this.selectedModel.join(","),
        ],
        [
          this.selectedGroup.length > 0,
          () => "Group: " + this.selectedGroup.join(","),
        ],
        [
          this.selectedLocation.length > 0,
          () => "Jobsite: " + this.selectedLocation.join(","),
        ],
        [this.selectedAlert, () => "Alert: " + this.selectedAlert],
        [
          this.selectedGPSReading.length > 0,
          () => "GPS Reading: " + this.selectedGPSReading.join(","),
        ],
      ];
      filterHeaderRows.forEach(([isActive, label]) => {
        if (isActive) {
          this.startrow += 1;
          this.excelHeader.push([label()]);
        }
      });
      this.excelHeader.push([]);
      this.startrow += 1;
      var ws;
      var wb;
      if (this.roles == "Customer") {
        if (
          this.companyIdDropdown == 7620 ||
          this.companyIdDropdown == 5704 ||
          this.companyIdDropdown == 1540
        ) {
          this.excelHeader.push([
            "Customer Name",
            "Equipment #",
            "Equipment Name",
            "Contract#",
            "Date Out",
            "Estimated Return Date",
            "Rental/Asset",
            "Asset Type",
            "Rental Status",
            "Item Status",
            "Brand",
            "Model",
            "Telematics SN",
            "Machine Battery Voltage",
            "DEF Level",
            "Fuel Level",
            "Payload Percentage",
            "Jobsite",
            "Customer Equipment Name",
            "Description",
            "Contractor",
            "Start Date",
            "End Date",
            "Customer Jobsite",
            "Last Known Address",
          ]);
          let tempExcel = this.excelList.map(function (item) {
            delete item.unitId;
            return item;
          });
          let datarow = "A" + this.startrow;
          ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "customerName",
              "stockKey",
              "name",
              "contractId",
              "contractStartDate",
              "contractEndDate",
              "isRental",
              "assetType",
              "contractStatus",
              "itemStatus",
              "manufacturer",
              "model",
              "tuSerialNumber",
              "batteryVoltage",
              "defLevel",
              "fuelLevel",
              "payloadPercentage",
              "jobSite",
              "description",
              "contractor",
              "startDate",
              "endDate",
              "customerJobsite",
              "lastKnownAddress",
            ],
            skipHeader: true,
            origin: datarow,
          });
          wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Equipment Data");
          this.excelHeader = [];
          XLSX.writeFile(wb, "Equipment Data.xlsx");
        } else {
          this.excelHeader.push([
            "Customer Name",
            "Equipment #",
            "Equipment Name",
            "Contract#",
            "Date Out",
            "Estimated Return Date",
            "Rental/Asset",
            "Asset Type",
            "Rental Status",
            "Item Status",
            "Brand",
            "Model",
            "Telematics SN",
            "Machine Battery Voltage",
            "DEF Level",
            "Fuel Level",
            "Payload Percentage",
            "Jobsite",
            "Last Known Address",
          ]);
          let tempExcel = this.excelList.map(function (item) {
            delete item.unitId;
            delete item.customerEquipmentName;
            delete item.description;
            delete item.customerJobsite;
            delete item.contractor;
            delete item.startDate;
            delete item.endDate;

            return item;
          });
          let datarow = "A" + this.startrow;
          ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "customerName",
              "stockKey",
              "name",
              "contractId",
              "contractStartDate",
              "contractEndDate",
              "isRental",
              "assetType",
              "contractStatus",
              "itemStatus",
              "manufacturer",
              "model",
              "tuSerialNumber",
              "batteryVoltage",
              "defLevel",
              "fuelLevel",
              "payloadPercentage",
              "jobSite",
              "lastKnownAddress",
            ],
            skipHeader: true,
            origin: datarow,
          });
          wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Equipment Data");
          this.excelHeader = [];
          XLSX.writeFile(wb, "Equipment Data.xlsx");
        }
      } else {
        this.excelHeader.push([
          "Customer Name",
          "Equipment #",
          "Equipment Name",
          "Contract#",
          "Date Out",
          "Estimated Return Date",
          "Rental/Asset",
          "Asset Type",
          "Rental Status",
          "Item Status",
          "Brand",
          "Model",
          "Telematics SN",
          "Machine Battery Voltage",
          "Estimated Battery Lifespan (days)",
          "DEF Level",
          "Fuel Level",
          "Payload Percentage",
          "Jobsite",
          "Description",
          "Contractor",
          "Start Date",
          "End Date",
          "Customer Jobsite",
          "Last Known Address",
        ]);
        let tempExcel = this.excelList.map(function (item) {
          delete item.unitId;
          return item;
        });
        let datarow = "A" + this.startrow;
        ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
        XLSX.utils.sheet_add_json(ws, tempExcel, {
          header: [
            "customerName",
            "stockKey",
            "name",
            "contractId",
            "contractStartDate",
            "contractEndDate",
            "isRental",
            "assetType",
            "contractStatus",
            "itemStatus",
            "manufacturer",
            "model",
            "tuSerialNumber",
            "batteryVoltage",

            "estimatedBatteryLifespan",
            "defLevel",
            "fuelLevel",
            "payloadPercentage",
            "jobSite",
            "description",
            "contractor",
            "startDate",
            "endDate",
            "customerJobsite",
            "lastKnownAddress",
          ],
          skipHeader: true,
          origin: datarow,
        });
        wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Equipment Data");
        this.excelHeader = [];
        XLSX.writeFile(wb, "Equipment Data.xlsx");
      }
    },

    checkIfImageExists(url, callback) {
      const img = new Image();
      img.src = url;

      if (img.complete) {
        callback(true);
      } else {
        img.onload = () => {
          callback(true);
        };

        img.onerror = () => {
          callback(false);
        };
      }
    },
    // Open & close window when click on marker/pin new
    openWindowdiv(item) {
      this.infowindowdiv = true;
      this.locationDetails = item;
      this.checkIfImageExists(item.imageUrl, (exists) => {
        if (exists) {
          this.imageExists = true;
        } else {
          this.imageExists = false;

        }
      });
    },
    //Active Contracts
    // The active filter set, in the exact key order the router query has always used.
    // Shared by the filter apply path and both view-details navigations.
    buildFilterQuery() {
      return {
        ...this.ownerTypeQuery,
        ...this.assetTypeQuery,
        ...this.brandQuery,
        ...this.rentalQuery,
        ...this.modelQuery,
        ...this.zoneQuery,
        ...this.groupQuery,
        ...this.alertsQuery,
        ...this.subTypeQuery,
        ...this.GPSReadingQuery,
        ...this.locationQuery,
        ...this.searchFieldQuery,
        ...this.searchContractFieldQuery,
        ...this.addressSearchQuery,
        ...this.searchStoreFieldQuery,
      };
    },
    viewRentalDetails(assetId) {
      let mapQuery = { navigateFrom: "Map" };
      this.viewfinalRouteQuery = { ...mapQuery, ...this.buildFilterQuery() };
      if (this.permissions.includes("On Rent Equipment")) {
        this.$router.push({
          name: "View Rental Equipment Details",
          params: {
            assetId: assetId,
          },
          query: this.viewfinalRouteQuery,
        });
      } else {
        this.$toast.error(
          "You don't have access to view Rental Equpment Details, please contact administrator."
        );
      }
    },
    viewAssetDetails(assetId) {
      let mapQuery = { navigateFrom: "Map" };
      this.viewfinalRouteQuery = { ...mapQuery, ...this.buildFilterQuery() };
      if (this.permissions.includes("Customer Owned Equipment")) {
        this.$router.push({
          name: "View Customer Owned Equipment Details",
          params: {
            assetId: assetId,
          },
          query: this.viewfinalRouteQuery,
        });
      } else {
        this.$toast.error(
          "You don't have access to view Customer Owned Equpment Details, please contact administrator."
        );
      }
    },
    clearSearch() {
      this.searchField = "";
      this.readCities();
    },
    clearContractSearch() {
      this.searchContractId = "";
      this.readCities();
    },
    clearSearchStoreId() {
      this.searchStoreId = "";
      this.readCities();
    },
    clearAddressSearch() {
      this.searchFieldAddress = "";
      this.readCities();
    },
    direction(item) {
      this.toggle_exclusive_map = 0;

      this.searchField = item.stockKey;
      this.readCities();
    },
    openZoneWindowdiv(item) {
      this.zoneDetails = {};
      this.zonewindowdiv = true;
      this.zoneDetails = item;
    },
    getCurrentMapId(value) {
      this.currentMapTypeId = value;
    },
    getCurrentZoom(zoom) {
      if (zoom > 11) {
        this.polygonOptions.strokeWeight = "5";
      } else {
        this.polygonOptions.strokeWeight = "5";
      }
    },
    async readContractsListFromApi() {
      this.isContractsLoading = true;
      this.contractsList = [];
      this.excelListContracts = [];
      try {
        let response =
          await telematicsService.getActiveContractsWithTelemactics(
            this.pageNumber,
            this.pageSize
          );
        if (response) {
          this.isContractsLoading = false;
          this.showtoggle = true;
          this.contractsList = response.data;
          this.contractsList = this.contractsList.map((d) => {
            return {
              ...d,
              lineItemNamesArray: d.lineItemNames
                ? d.lineItemNames.split("|")
                : "",
            };
          });

          const formatDate = "MM/DD/YYYY";

          this.excelListContracts = this.contractsList.map((item) => {
            return {
              contractId: item.id ? item.id + "-" + item.depotId : "",
              orderedBy: item.orderedBy ? item.orderedBy : "",
              receivedBy: item.receivedBy ? item.receivedBy : "",
              startDateTime: item.startDateTime
                ? moment(item.startDateTime).format(formatDate)
                : "",
              endDateTime: item.endDateTime
                ? moment(item.endDateTime).format(formatDate)
                : "",
              contractStatus: item.contractStatus ? item.contractStatus : "",
              po: item.customerPurchaseOrder ? item.customerPurchaseOrder : "",
              jobsite: item.jobsite ? item.jobsite : "",
              lineItems: item.lineItems ? item.lineItems : "",
              customerJobNumber: item.customerJobNumber
                ? item.customerJobNumber
                : "",
            };
          });
          for (let r = 0; r < this.excelListContracts.length; r++) {
            if (this.excelListContracts[r].lineItems.length > 0) {
              for (
                let d = 0;
                d < this.excelListContracts[r].lineItems.length;
                d++
              ) {
                this.excelListContracts[r].lineItems[d]["startDateTime"] =
                  this.excelListContracts[r].startDateTime;
                this.excelListContracts[r].lineItems[d]["endDateTime"] =
                  this.excelListContracts[r].endDateTime;
                this.excelListContracts[r].lineItems[d]["contractId"] =
                  this.excelListContracts[r].contractId;
                this.excelListContracts[r].lineItems[d]["orderedBy"] =
                  this.excelListContracts[r].orderedBy;
                this.excelListContracts[r].lineItems[d]["receivedBy"] =
                  this.excelListContracts[r].receivedBy;
                this.excelListContracts[r].lineItems[d]["po"] =
                  this.excelListContracts[r].po;
                this.excelListContracts[r].lineItems[d]["contractStatus"] =
                  this.excelListContracts[r].contractStatus;
                this.excelListContracts[r].lineItems[d]["customerJobNumber"] =
                  this.excelListContracts[r].customerJobNumber;
              }
            }
          }
          this.tempList = this.excelListContracts
            .map((e) => e.lineItems)
            .flat();
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
          if (response.data.length == 0) {
            this.shownodata = true;
          } else {
            this.shownodata = false;
          }
        } else {
          this.isContractsLoading = false;
          this.showtoggle = true;

          this.contractsList = [];
        }
      } catch (err) {
        this.isContractsLoading = false;
        this.showtoggle = true;
        console.log(err);

      }
    },
    async readContractDetailsFromId(Id) {
      this.isDetailsLoading = true;
      try {
        let response = await telematicsService.getcontractsDataById(Id);
        if (response.isSuccess) {
          this.isDetailsLoading = false;
          this.yesdata = true;
          this.nodata = false;
          this.viewDataById = response.data;
          this.responseData = response.data;
          this.responseData.singleaddress =
            this.responseData.addresses[0].city +
            ", " +
            this.responseData.addresses[0].line1 +
            " " +
            this.responseData.addresses[0].postalCode;
          this.responseData.customerPickup.address =
            this.responseData.customerPickup.address == null
              ? ""
              : this.responseData.customerPickup.address;
          this.responseData.driverDelivery.dateTime = this.responseData
            .driverDelivery.dateTime
            ? moment(this.responseData.driverDelivery.dateTime).format(
                "MM/DD/YY"
              )
            : "";
          this.responseData.customerPickup.dateTime = this.responseData
            .customerPickup.dateTime
            ? moment(this.responseData.customerPickup.dateTime).format(
                "MM/DD/YY"
              )
            : "";
          this.responseData.driverPickup.dateTime = this.responseData
            .driverPickup.dateTime
            ? moment(this.responseData.driverPickup.dateTime).format("MM/DD/YY")
            : "";
          if (this.responseData.driverPickup.locationName == "") {
            this.showdriverPickup = false;
          } else {
            this.showdriverPickup = true;
          }
          if (this.responseData.customerPickup.locationName != "") {
            this.responseData.customerPickup.locationName =
              this.responseData.customerPickup.locationName.split("-")[1];
          }
          if (this.responseData.driverDelivery.locationName == "") {
            this.showdriverdelivery = false;
          } else {
            this.showdriverdelivery = true;
          }

        } else {
          this.isDetailsLoading = false;
          this.nodata = true;
          this.yesdata = false;

          this.viewDataById = {};
          this.responseData = {
            driverDelivery: {
              dateTime: "",
            },
            customerPickup: {
              dateTime: "",
            },
            driverPickup: {
              dateTime: "",
            },
          };
        }
      } catch (error) {
        this.isDetailsLoading = false;
        this.$toast.error("Unable to load the data" + error);
      }
    },
    exportTableDataContracts() {
      this.excelHeaderContracts = [];
      this.startrowContracts = 3;
      this.excelHeaderContracts.push(["Contracts Data"]);
      this.startrowContracts += 1;
      let cust;
      if (this.companyNameDropdown == "") {
        cust = "All";
      } else {
        cust = this.$store.getters.companyNameDropdown;
      }
      this.excelHeaderContracts.push(["Customer:" + " " + cust]);
      this.excelHeaderContracts.push([]);
      this.startrowContracts += 1;
      this.excelHeaderContracts.push([
        "Contract#",
        "Equipment #",
        "Equipment Name",
        "PO#",
        "Ordered By",
        "Picked Up by",
        "Job Number",
        "Date Out",
        "Date Due",
        "Status",
      ]);
      let tempExcel = this.tempList.map(function (item) {
        delete item.stockId;
        delete item.classification;
        return item;
      });
      let datarow = "A" + this.startrowContracts;
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeaderContracts);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header: [
          "contractId",
          "stockKey",
          "stockName",
          "po",
          "orderedBy",
          "receivedBy",
          "customerJobNumber",
          "startDateTime",
          "endDateTime",
          "contractStatus",
        ],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Contracts Data");
      this.excelHeaderContracts = [];
      XLSX.writeFile(wb, "Active Contracts Data.xlsx");
    },
    pageChange() {
      this.readContractsListFromApi();
    },
    viewContractDetails(id) {
      this.showDialog = true;
      this.readContractDetailsFromId(id);
      this.contractsList.map((item) => {
        if (item.id == id) {
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      });
    },
    closeDialog() {
      this.nodata = false;
      this.yesdata = false;
      this.showDialog = false;
      this.responseData = {
        driverDelivery: {
          dateTime: "",
        },
        customerPickup: {
          dateTime: "",
        },
        driverPickup: {
          dateTime: "",
        },
      };

      this.nodata = false;
      this.yesdata = false;
    },
    //Create Geofence Methods
    async getGeofences() {
      this.createdPolygonsList = [];
      this.polygons = [];
      try {
        let response = await telematicsService.getGeofences();

        if (response && response.data) {
          this.createdPolygonsList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
            editablePolygon: d.polygon.length >= 3 ? false : true,
          }));
        } else {
          this.createdPolygonsList = [];
        }
        this.polygons = this.currentLocationPolygons.concat(
          this.createdPolygonsList
        );
        this.handleHidingCustomGeofences(this.hideCustomGeofences);
      } catch (err) {
        console.log(err);
      }
    },
    openGeofenceFilters() {
      this.markers = [];
      this.polygonsFiltered = [];
      this.showGeofenceSearchFilters = true;

      this.selectedgeofenceSearchItem = "Select Geofence On Map";

      this.getCurrentCenter1();
      if (this.selectedgeofenceSearchItem != "Search By Address") {
        this.resetGeofenceFilters();
      }
    },
    closeGeofenceFilters() {
      this.showGeofenceSearchFilters = false;
      if (this.selectedgeofenceSearchItem != "") {
        this.readCities();
      }
      this.selectedgeofenceSearchItem = "";
      this.resetGeofenceFilters();
      this.ClearGeofenceDetails();
    },
    resetGeofenceFilters() {
      this.currentLocationPolygons = [];
      this.polygons = this.currentLocationPolygons.concat(
        this.createdPolygonsList
      );
      this.handleHidingCustomGeofences(this.hideCustomGeofences);
    },
    getCurrentCenter(center) {
      if (this.selectedgeofenceSearchItem == "Select Geofence On Map") {
        this.userCurrentLocation = {
          lat: center.latLng.lat(),
          lng: center.latLng.lng(),
        };
        this.center = this.userCurrentLocation;
        let currentLocationObj = {
          polygon: [],
          editablePolygon: true,
        };
        let polygon = [];
        this.currentLocationPolygons = [];
        polygon.push(this.userCurrentLocation);
        polygon.push(this.userCurrentLocation);
        currentLocationObj["polygon"] = polygon;
        this.currentLocationPolygons.push(currentLocationObj);
        this.polygons = this.currentLocationPolygons.concat(
          this.createdPolygonsList
        );
        this.handleHidingCustomGeofences(this.hideCustomGeofences);
      }
    },
    getCurrentCenter1() {
      let center = this.center;
      if (this.selectedgeofenceSearchItem == "Select Geofence On Map") {
        this.userCurrentLocation = {
          lat: center.latLng.lat(),
          lng: center.latLng.lng(),
        };
        this.center = this.userCurrentLocation;
        this.zoom = 18;

        let currentLocationObj = {
          polygon: [],
          editablePolygon: true,
        };
        let polygon = [];
        this.currentLocationPolygons = [];
        polygon.push(this.userCurrentLocation);
        polygon.push(this.userCurrentLocation);
        currentLocationObj["polygon"] = polygon;
        this.currentLocationPolygons.push(currentLocationObj);
        this.polygons = this.currentLocationPolygons.concat(
          this.createdPolygonsList
        );
        this.handleHidingCustomGeofences(this.hideCustomGeofences);

      }
    },
    updatePath(mvcArray) {
      this.getCurrentZoom(17);
      this.finalGeofencePaths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let p = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          p.push({
            lat: mvcArray.getAt(i).getAt(j).lat(),
            lng: mvcArray.getAt(i).getAt(j).lng(),
          });
        }
        this.finalGeofencePaths = p;
      }
    },
    ClearGeofenceDetails() {
      this.name = "";
      this.description = "";
      this.finalGeofencePaths = [];
    },
    async createGeofence() {
      if (this.finalGeofencePaths.length >= 3) {
        this.finalGeofencePaths.push(this.finalGeofencePaths[0]);
        this.isCreating = true;
        try {
          let payload = {
            name: this.name,
            description: this.description,
            customerId:
              this.companyNameDropdown == "All" ||
              this.companyNameDropdown == "" ||
              this.companyNameDropdown == null
                ? ""
                : String(this.companyIdDropdown),
            customerName:
              this.companyNameDropdown == "All" ||
              this.companyNameDropdown == "" ||
              this.companyNameDropdown == null
                ? ""
                : this.companyNameDropdown,
            polygons: this.finalGeofencePaths,
            userName: this.fullname,
            createdBy: this.fullname,
            userId: this.id,
          };
          let response = await telematicsService.createGeofence(payload);
          if (response.isSuccess) {
            this.$toast.success("Geofence added successfully");
            this.isCreating = false;
            this.center = {};
            this.userCurrentLocation = {};
            this.currentLocationPolygons = [];
            this.createdPolygonsList = [];
            this.polygons = [];
            this.handleHidingCustomGeofences(this.hideCustomGeofences);
            this.readCities();
            this.ClearGeofenceDetails();
            this.closeGeofenceFilters();
          } else {
            this.$toast.error(response.systemMessage);
            this.isCreating = false;
          }
          this.finalGeofencePaths = [];
        } catch (err) {
          this.isCreating = false;
          this.$toast.error("Unable to add the Geofence" + err);
        }
      } else {
        this.$toast.error("Invalid Geofence, Please draw valid Geofence.");
      }
    },
    async gotoAddressLocation() {
      this.center = {};
      if (this.searchFieldAddress) {
        this.zoom = 18;
        try {
          let response = await googleMapsService.getLocationFromZip(
            this.searchFieldAddress,
            config.GOOGLE_MAPS_API
          );
          if (response && response.results && response.results.length > 0) {
            let center = {
              lat: response.results[0].geometry.location.lat,
              lng: response.results[0].geometry.location.lng,
            };
            this.center = center;
            this.zoom = 18;

            this.loading = false;
          } else {
            this.loading = false;
            this.$toast.error("No results found for provided address.");
            this.geolocate();
          }
        } catch (err) {
          this.loading = false;
          this.geolocate();
          console.log(err);
        }
      }
    },
  },
};
